import {
  EmailShareButton,
  FacebookShareButton,
  PinterestShareButton,
  RedditShareButton,
  TumblrShareButton,
  TwitterShareButton,
  VKShareButton,
  WeiboShareButton,
  WhatsappShareButton,
} from 'next-share';

import {
  facebookIcon,
  mailIcon,
  pinterestIcon,
  redditIcon,
  tumblrIcon,
  vkIcon,
  weiboIcon,
  whatsappIcon,
  xIcon,
} from './icons';
import type { GetSocialConfig } from './types';

export const getSocialConfig: GetSocialConfig = (url, title, subject) => [
  {
    provider: 'Facebook',
    component: FacebookShareButton,
    icon: facebookIcon,
    props: { url, quote: title },
  },
  {
    provider: 'X',
    component: TwitterShareButton,
    icon: xIcon,
    props: { url, title },
  },
  {
    provider: 'Pinterest',
    component: PinterestShareButton,
    icon: pinterestIcon,
    props: { url, media: title },
  },
  {
    provider: 'Tumblr',
    component: TumblrShareButton,
    icon: tumblrIcon,
    props: { url, title },
  },
  {
    provider: 'Reddit',
    component: RedditShareButton,
    icon: redditIcon,
    props: { url, title },
  },
  {
    provider: 'VK',
    component: VKShareButton,
    icon: vkIcon,
    props: { url },
  },
  {
    provider: 'WhatsApp',
    component: WhatsappShareButton,
    icon: whatsappIcon,
    props: { url, title },
  },
  {
    provider: 'Weibo',
    component: WeiboShareButton,
    icon: weiboIcon,
    props: { url },
  },
  {
    provider: 'Email',
    component: EmailShareButton,
    icon: mailIcon,
    props: { url, subject, body: '' },
  },
];
